// extracted by mini-css-extract-plugin
export default {"truncated":"TruncatedText_truncated__-iSTL"};